<template>
      <div class="copyright">© 2023 武汉摩鸣科技有限公司 版权所有 <span @click="open" style="cursor: pointer;">鄂ICP备18014157号-3</span></div>
</template>

<script>
export default {
  name: 'Bottom',
  data () {
    return {}
  },
  methods: {
    open() {
      window.open('https://beian.miit.gov.cn', '_blank');
    },
  },
}
</script>

<style lang="less" scoped>
  .copyright {
    font-size: 12px;
    color: #c5c5c5;
    position: fixed;
    z-index: 9999;
    left: 50%;
    bottom: 8px;
    transform: translateX(-50%);
  }
</style>
